import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { RhinoMindSection } from './components/RhinoMindSection';
import { BookSection } from './components/BookSection';
import { CommunitySection } from './components/CommunitySection';
import { SocialsSection } from './components/SocialsSection';
import { ShopSection } from './components/ShopSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-rhino-black text-white selection:bg-rhino-gold selection:text-rhino-black overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <RhinoMindSection data-id="element-5" />
        <BookSection data-id="element-6" />
        <CommunitySection data-id="element-7" />
        <SocialsSection data-id="element-8" />
        <ShopSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}